import React from 'react';

import { Seats, ErrorHandler } from '../../api';
import { Widget } from '../Widget/Widget';
import { numberWithCommas } from '../../utils';
import ShortDashWidget from '../ShortDashWidget/ShortDashWidget';

export default class WidgetSeats extends React.Component {
  _isMounted = false;

  constructor() {
    super();

    this.state = {
      isLoading: true,
      seatCount: null,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this._fetch();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  safeSetState = (newState, callback) => {
    if (this._isMounted) {
      this.setState(newState, callback);
    }
  };

  _fetch = async () => {
    this.safeSetState({ isLoading: true });

    let res;
    try {
      res = await Seats.dashboardStats();
    } catch (err) {
      ErrorHandler.error(err);
    }

    let seatCount = null;
    let addedSeatCount = 0;
    if (res && res.body && res.body.data && res.body.data.length) {
      const { data } = res.body;
      const today = new Date();
      const month = today.getUTCMonth() + 1;
      const year = today.getUTCFullYear();
      const todaysData = data.find(
        item => item.month === month && item.year === year
      );
      seatCount = (todaysData && todaysData.seat_count) || 0;
      addedSeatCount = (todaysData && todaysData.newly_added_seat_count) || 0;
    }
    this.safeSetState({
      isLoading: false,
      seatCount,
      addedSeatCount,
    });
  };

  render() {
    const { seatCount, isLoading, addedSeatCount } = this.state;
    return (
      <Widget
        isLoading={isLoading}
        link="/devices/seats"
        widgetName="WidgetSeats"
        title="Seats"
        subtitle="as of today"
        isEmpty={!seatCount && seatCount !== 0}
        emptyStateMessage="No seat data found."
        className="seats-widget widget-loader-right height-1">
        <ShortDashWidget
          number={numberWithCommas(seatCount)}
          subnumber={
            addedSeatCount > 0 ? `+${numberWithCommas(addedSeatCount)}` : null
          }
        />
      </Widget>
    );
  }
}
